import { render, staticRenderFns } from "./my-setting.vue?vue&type=template&id=6de9b47c&scoped=true"
import script from "./my-setting.vue?vue&type=script&lang=ts"
export * from "./my-setting.vue?vue&type=script&lang=ts"
import style0 from "./my-setting.vue?vue&type=style&index=0&id=6de9b47c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9b47c",
  null
  
)

export default component.exports